import fetch from 'src/assets/api/fetch'

export default {
  get (url: string, token?: string | undefined): Promise<Response> {
    return fetch(url, {
      method: 'GET',
      redirect: 'manual'
    }, token)
  },
  post (url: string, data = {}, token?: string | undefined): Promise<Response> {
    return fetch(url, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      redirect: 'manual',
      body: JSON.stringify(data)
    }, token)
  },
  patch (url: string, data = {}, token?: string | undefined): Promise<Response> {
    return fetch(url, {
      method: 'PATCH',
      headers: { 'content-type': 'application/json' },
      redirect: 'manual',
      body: JSON.stringify(data)
    }, token)
  },
  put (url: string, data = {}, token?: string | undefined): Promise<Response> {
    return fetch(url, {
      method: 'PUT',
      headers: { 'content-type': 'application/json' },
      redirect: 'manual',
      body: JSON.stringify(data)
    }, token)
  },
  delete (url: string, token?: string | undefined): Promise<Response> {
    return fetch(url, {
      method: 'DELETE',
      redirect: 'manual'
    }, token)
  },
  submit (url: string, form: FormData, token?: string | undefined): Promise<Response> {
    return fetch(url, {
      method: 'POST',
      redirect: 'manual',
      body: form
    }, token)
  },
  upload (url: string, form: FormData, token: string, onProgress: ((event: ProgressEvent) => void) | undefined): Promise<ProgressEvent> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      xhr.open('post', url)
      xhr.setRequestHeader('Authorization', `Bearer ${token}`)
      xhr.onload = event => resolve(event) // event.target.responseText
      xhr.onerror = reject
      if (xhr.upload && onProgress) {
        xhr.upload.onprogress = onProgress // event.loaded / event.total * 100 //event.lengthComputable
      }
      xhr.send(form)
    })
  }
}
